

export function frameShapeToName(shape: string) {
    if (!shape) return '';
    if (shape === 'classic') return 'Original';
    if (shape === 'round') return 'Capote';
    if (shape === 'rectangle') return 'Original';
    return '';
}